module.exports = __webpack_public_path__ + "static/media/shape0_1.87b11a99.obj";